<span class="label"
      tooltipStyleClass="app-info-tooltip"
      tooltipEvent="hover"
      [pTooltip]="tooltip || (display | translate)">
    <span class="value" [class.with-icon]="valueIcon">
        <app-icon *ngIf="valueIcon"
                  class="value-icon"
                  [library]="iconLibrary"
                  [variant]="valueIcon"
                  [type]="iconType"
                  [simple]="true">
        </app-icon>
    </span>
    <span class="name">
        {{name | translate}}
    </span>
    <span class="value-text">{{display | translate}}</span>
</span>
